export default [
	 {//请假管理
		path: 'leave_application',
		name: 'm_leave_application',
		meta: {
			appView: {
				viewId: '10012',
				auth: 'b_leave_application_viewmanage'
			}
		},
		component: () => import('@/pages/basic/leave_application_list.vue')
	},
	 {//加班申请管理
		path: 'overtime_application',
		name: 'm_overtime_application',
		meta: {
			appView: {
				viewId: '10014',
				auth: 'b_overtime_application_viewmanage'
			}
		},
		component: () => import('@/pages/basic/overtime_application_list.vue')
	},
];